import { IUserViewModel } from '../../types/interfaces'
import { ActionType } from './actionTypes'

export function saveuser(user?: IUserViewModel | null) {
  return { type: ActionType.SET_USER, user }
}

export function saveManager(manager: string) {
  return { type: ActionType.SET_MANAGER, manager }
}
